import { rejectInvalidSyncKey } from 'serviceWorker/services/factories/invalidSyncKey';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { VisibleFieldInDto } from 'shared/dtos/in/visibleField';
import {
  defaultConfig,
  generateHeaders,
  parseResponse,
} from 'serviceWorker/helpers/httpRequests';
import {
  HeadersData,
  NormalizedEntityResponseData,
} from '../factories/types';
import { pull } from '../pull';

type ParseResponse = () => Promise<
  NormalizedEntityResponseData<VisibleFieldInDto>
>;

export const fetchVisibleFields = (
  data: HeadersData,
  controller: AbortController
):
  | Promise<NormalizedEntityResponseData<VisibleFieldInDto>>
  | undefined => {
  const { signal } = controller;
  if (shouldSkip(data, signal)) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/visibleField`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then((parseResponse as ParseResponse));
};

export const fetchUpdatedVisibleFields = (
  data: HeadersData,
  syncKey: string,
  controller: AbortController
):
  | Promise<NormalizedEntityResponseData<VisibleFieldInDto>>
  | undefined => {
  const { signal } = controller;
  if (!data.api || !data.projectId) {
    //not enough data, skip.
    return;
  }
  const builtUrl = `${data.api}/v2/project/${
    data.projectId
  }/visibleField?syncKey=${encodeURIComponent(syncKey)}`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  })
    .then((response: Response) => rejectInvalidSyncKey(response, 'visibleFields'))
    .then((parseResponse as ParseResponse));
};

function shouldSkip(data: HeadersData, signal: AbortSignal): boolean {
  return !data.api || !data.projectId || signal.aborted;
}
